import { PlanTab } from '../../../../../components/verification/SubscriptionStep';
import { SubscriptionTerm } from '../../../../../services/exports/Constants';

export default {
  sections: {
    term: {
      description: 'Laskutetaan kuukausittain. Vuosisopimus on sitoumuskausi, ei laskutustiheys.',
      options: {
        [SubscriptionTerm.Monthly]: 'Kuukausisopimus',
        [SubscriptionTerm.Annual]: 'Vuosisopimus',
      },
    },
    plans: {
      tabs: {
        [PlanTab.actual]: {
          name: 'Hintamalli',
          title: 'Suoritukseen perustuva hinnoitteluasteikko',
        },
        [PlanTab.legacy]: {
          name: 'Vanha',
          title: 'Paketit',
        },
      },
    },
    add_ons: {
      title: 'Päivity Proksi lisäosillamme Essential-pakettiisi',
      description: 'Houkuttele uusia asiakkaita ja lisää käyntejä näillä ohjelmistoratkaisuilla.',
    },
  },
  labels: {
    recommended: 'Suositeltu',
    basket: 'Ostoskori: <strong>{{amount}}</strong> / kk',
  },
  buttons: {
    review_and_subscribe: 'Tarkista ja tilaa',
    cancel: 'Peruuta',
    basket: 'Takaisin ostoskoriin',
    subscribe: 'Tilaa',
    update_subscription: 'Päivitä tilaus',
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
    failed_to_save_contract: 'Palvelusopimuksen tallentaminen epäonnistui',
    failed_to_create_subscription: 'Tilauksen luominen epäonnistui',
    subscription_created: 'Tilaus luotu onnistuneesti',
    subscription_updated: 'Tilaus päivitetty onnistuneesti',
  },
};
